import {
  CLEAR_PROPOSAL,
  SEND_PROPOSAL,
  SEND_PROPOSAL_SUCCESS,
  SEND_PROPOSAL_ERROR,
} from '../constants/proposal';

export const SendProposal = payload => ({
  type: SEND_PROPOSAL,
  payload,
});

export const SendProposalSuccess = payload => ({
  type: SEND_PROPOSAL_SUCCESS,
  payload,
});

export const SendProposalError = payload => ({
  type: SEND_PROPOSAL_ERROR,
  payload,
});

export const ClearSentProposal = () => ({
  type: CLEAR_PROPOSAL,
});
